import React, { useEffect } from "react";
import { DiReact } from "react-icons/di";
import { SiTailwindcss } from "react-icons/si";
import { FaFigma } from "react-icons/fa";
import { TbBrandJavascript, TbBrandCss3, TbBrandHtml5 } from "react-icons/tb";
import Aos from "aos";
import "aos/dist/aos.css";

const Skills = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  return (
    <div className="px-[20px] font-serif mt-[50px] lg:mt-[150px] lg:px-[100px]">
      <h1 className="text-center text-[#E84949] p-4 text-2xl font-bold">
        Skills
      </h1>
      <div className=" lg:flex justify-between">
        <div className="lg:flex flex-col gap-[20px] justify-center">
          <h1>Technologies that I have worked with:</h1>
          <ul
            data-aos="zoom-in"
            className="grid grid-cols-2 md:grid-cols-3 lg:flex gap-6"
          >
            <li className="flex flex-col items-center">
              <TbBrandHtml5 size={60} className="text-[#E84949]" />
              HTML
            </li>
            <li className="flex flex-col items-center">
              <TbBrandCss3 size={60} className="text-[#E84949] " />
              CSS
            </li>
            <li className="flex flex-col items-center">
              <SiTailwindcss size={60} className="text-[#E84949] w-[94px]" />
              Tailwind
            </li>
            <li className="flex flex-col items-center">
              <TbBrandJavascript
                size={60}
                className="text-[#E84949] w-[94px]"
              />
              JavaScript
            </li>
            <li className="flex flex-col items-center">
              <DiReact size={60} className="text-[#E84949] text-center" />
              ReactJS
            </li>
            <li className="flex flex-col items-center">
              <FaFigma size={60} className="text-[#E84949] text-center" />
              Figma
            </li>
          </ul>
        </div>
        <div data-aos="fade-left">
          <img
            src="/portfolio.png"
            alt=""
            className="hidden lg:flex h-[400px] w-[411px] rounded"
          />
        </div>
      </div>
    </div>
  );
};

export default Skills;
